import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';
import styled from 'packages/theming';
import { Box, Logo, Text, constants } from '@match/react-component-library';

const { SEMANTIC_COLOR_NAME, SPACE, TYPOGRAPHY } = constants;

interface FooterProps {
  isMobi?: boolean;
}

const Footer: React.FunctionComponent<FooterProps> = ({ isMobi }) => {
  return (
    <div>
      <Box height={50} />
      <Box
        bottom="none"
        left="none"
        right="none"
        center
        display="flex"
        paddingLeft={isMobi ? undefined : SPACE.LARGE}
        position="fixed"
        width="100%"
        height={50}
        backgroundColor="light"
      >
        {!isMobi && (
          <Box width="100%" maxWidth={200}>
            <Logo width={35} height={35} size="abbreviated" />
          </Box>
        )}
        <StyledBox
          display="flex"
          justifyContent="space-between"
          width={isMobi ? '100vw' : '60vw'}
          paddingX={isMobi ? SPACE.SMALL : SPACE.NONE}
          textAlign={isMobi ? 'center' : undefined}
        >
          <a href="/registration/membagr.aspx?lid=4" target="_blank">
            <Text color={SEMANTIC_COLOR_NAME.GRAY_100} typography={TYPOGRAPHY.SMALL_BODY}>
              <FormattedMessage {...messages.termsOfUse} />
            </Text>
          </a>
          {isMobi && (
            <Box paddingX={SPACE.XSMALL} color={SEMANTIC_COLOR_NAME.GRAY_100}>
              <Text>|</Text>
            </Box>
          )}
          <a href="/registration/privacystatement.aspx?lid=4" target="_blank">
            <Text color={SEMANTIC_COLOR_NAME.GRAY_100} typography={TYPOGRAPHY.SMALL_BODY}>
              <FormattedMessage {...messages.privacy} />
            </Text>
          </a>
          {isMobi && (
            <Box paddingX={SPACE.XSMALL} color={SEMANTIC_COLOR_NAME.GRAY_100}>
              <Text>|</Text>
            </Box>
          )}
          <a href="/help/safetytips.aspx?lid=4" target="_blank">
            <Text color={SEMANTIC_COLOR_NAME.GRAY_100} typography={TYPOGRAPHY.SMALL_BODY}>
              <FormattedMessage {...messages.safetyTips} />
            </Text>
          </a>
          {isMobi && (
            <Box paddingX={SPACE.XSMALL} color={SEMANTIC_COLOR_NAME.GRAY_100}>
              <Text>|</Text>
            </Box>
          )}
          <a href="/registration/cookiepolicy.aspx" target="_blank">
            <Text color={SEMANTIC_COLOR_NAME.GRAY_100} typography={TYPOGRAPHY.SMALL_BODY}>
              <FormattedMessage {...messages.cookies} />
            </Text>
          </a>
        </StyledBox>
      </Box>
    </div>
  );
};

export default Footer;

const StyledBox = styled(Box)(() => {
  return {
    flexBasis: 'auto',
  };
});

const messages = defineMessages({
  termsOfUse: {
    id: 'src/modules/components/Footer/Footer:termsOfUse',
    description: 'terms of use link',
    defaultMessage: 'Terms of use',
  },
  privacy: {
    id: 'src/modules/components/Footer/Footer:privacy',
    description: 'privacy link',
    defaultMessage: 'Privacy',
  },
  safetyTips: {
    id: 'src/modules/components/Footer/Footer:safetyTips',
    description: 'safety tips link',
    defaultMessage: 'Safety Tips',
  },
  cookies: {
    id: 'src/modules/components/Footer/Footer:cookies',
    description: 'cookies link',
    defaultMessage: 'Cookies',
  },
});
